import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { FormattedMessage, injectIntl } from 'react-intl'

import ValidateForm from '../../../../../app/components/common/ValidateForm'
import { ACCOUNT, APP, GA_EVENT } from '../../../../EventTypes'
import { applyInvoice } from '../../../../APIs'
import Contact from './Contact'

const initState = {
  amounts: ['0'],
  isCompany: false,
  contents: ['星巴克预付款卡销售'],
  titles: [''],
  ticketNumbers: [''],
  authorizeCodes: [''],
  taxNo: '',
  extras: {
    billAddress: '', //province + city + address || email
    addressee: '',
    phone: '',
    postcode: ''
  },
  requesting: false,
  isInvoiceTitleAutoValidate: false
}

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = { ...initState }
  }

  calculateAmount(amounts) {
    const userComeFromAccountPage = /\/account/.test(window.location.pathname)
    const userComeFromInvoicePage = /\/invoice/.test(window.location.pathname)
    let amount = 0

    if (userComeFromAccountPage) {
      amount = amounts.map(v => parseFloat(v)).reduce((sum, value) => sum + value) / 100
    } else if (userComeFromInvoicePage) {
      amount = amounts.map(v => parseFloat(v)).reduce((sum, value) => sum + value)
    }

    return amount
  }

  componentWillMount() {
    this.eventListener = window.eventEmitter.addListener(
      ACCOUNT.OPEN_INVOICE_APPLICATION_MODAL,
      ({ amounts, ticketNumbers, authorizeCodes, callback }) => {


        this.props.switchApplicationForm(true, () => {
          findDOMNode(this.refs.container).scrollIntoView()
        })

        this.setState({
          // amounts: <Array>{ <string> }
          amounts: [this.calculateAmount(amounts).toString()],
          ticketNumbers,
          authorizeCodes
        })
        this.callback = callback
      }
    )
  }

  componentWillUnmount() {
    this.eventListener.remove()
  }

  callback = null

  onClickSubmit() {
    const invoiceTitleHasError = this.refs.invoiceTitle.validate().hasError
    const contactHasError = this.refs.contact.hasError()

    let taxNoHasError = false
    if (this.refs.taxNo) {
      taxNoHasError = this.refs.taxNo.validate().hasError
    }

    if (invoiceTitleHasError) {
      findDOMNode(this.refs.invoiceTitle).scrollIntoView()
      return
    }

    if (taxNoHasError) {
      findDOMNode(this.refs.taxNo).scrollIntoView()
      return
    }

    if (contactHasError) {
      findDOMNode(this.refs.contact).scrollIntoView()
      return
    }

    const {
      amounts,
      isCompany,
      contents,
      titles,
      taxNo,
      ticketNumbers,
      authorizeCodes,
      extras
    } = this.state

    if (extras.postcode === '') {
      delete extras.postcode
    }

    if (extras.addressee === '') {
      delete extras.addressee
    }

    const payload = {
      data: {
        amounts,
        isCompany,
        contents,
        titles,
        taxNo,
        ticketNumbers,
        authorizeCodes,
        extras
      }
    }

    this.setState({ requesting: true })

    applyInvoice(payload)
      .then(() => {
        window.eventEmitter.emit(GA_EVENT.APPLY_INVOICE_SUCCESS);
        window.eventEmitter.emit(APP.SHOW_NOTIFICATION, ['invoice', '200'])
        this.callback && this.callback()
        this.setState({ requesting: false })
        this.closeApplicationModal()
        this.props.switchApplicationForm(false)
      })
      .catch(err => {
        window.eventEmitter.emit(GA_EVENT.APPLY_INVOICE_FAILURE);
        this.setState({ requesting: false })
        try {
          window.eventEmitter.emit(APP.SHOW_NOTIFICATION, [
            'invoice',
            err.response.data.error.code
          ])
        } catch (error) {
          window.eventEmitter.emit(APP.SHOW_NOTIFICATION, [
            'invoice',
            'default'
          ])
        }
      })
  }

  closeApplicationModal() {
    this.setState({ ...initState })
  }

  resetExtras() {
    this.setState({
      extras: {
        billAddress: '',
        phone: '',
        addressee: '',
        postcode: ''
      }
    })
  }

  goBack() {
    this.props.switchApplicationForm(false)
    this.setState({ ...initState })

    this.callback && this.callback()
  }

  render() {
    const {
      amounts,
      isCompany,
      taxNo,
      titles,
      extras: { billAddress, phone, addressee, postcode }
    } = this.state

    if (!this.props.isApplicationFormActive) {
      return <div />
    }

    return (
      <div ref="container">
        <FormattedMessage id="Invoice Information">
          {text => <p className="h2">{text}</p>}
        </FormattedMessage>
        <table>
          <tbody>
            <tr>
              <FormattedMessage tagName="td" id="Company" />
              <FormattedMessage
                tagName="td"
                id="Starbucks (Shanghai) Trade Company Limited"
              />
            </tr>
            <tr>
              <FormattedMessage tagName="td" id="Amts" />
              <td>¥ {amounts[0]}</td>
            </tr>
          </tbody>
        </table>
        <div className="field radios">
          <div>
            <input
              name="radio-individual"
              id="radio-individual"
              type="radio"
              checked={!isCompany}
              onChange={() => this.setState({ isCompany: false })}
            />
            <label htmlFor="radio-individual">
              <FormattedMessage id="Individual" />
            </label>
          </div>
          <div>
            <input
              name="radio-interprise"
              id="radio-interprise"
              type="radio"
              checked={isCompany}
              onChange={() => this.setState({ isCompany: true })}
            />
            <label htmlFor="radio-interprise">
              <FormattedMessage id="Enterprise" />
            </label>
          </div>
        </div>
        <ValidateForm
          ref="invoiceTitle"
          autoValidate={this.state.isInvoiceTitleAutoValidate}
        >
          <input
            name="invoiceTitle"
            type="text"
            value={titles[0]}
            onChange={e => {
              if (e.target.value.length < 100) {
                this.setState({ titles: [e.target.value] })
              }
            }}
            onBlur={e => {
              if (!this.state.isInvoiceTitleAutoValidate) {
                this.setState({ isInvoiceTitleAutoValidate: true })
              }
            }}
            placeholder={this.props.intl.formatMessage({
              id: isCompany ? 'Company Name' : 'Invoice Title'
            })}
            data-error-isRequired
          />
        </ValidateForm>
        {isCompany ? (
          <ValidateForm ref="taxNo">
            <input
              name="taxNo"
              type="text"
              value={taxNo}
              onChange={e => {
                if (/^[a-zA-Z0-9]{0,50}$/.test(e.target.value)) {
                  this.setState({ taxNo: e.target.value })
                }
              }}
              placeholder={this.props.intl.formatMessage({
                id: 'Taxpayer ID'
              })}
              data-error-isRequired
            />
          </ValidateForm>
        ) : null}
        <div className="field">
          <FormattedMessage id="Invoice Content">
            {text => <label htmlFor="invoice-contents">{text}</label>}
          </FormattedMessage>
          <div className="select">
            <select
              id="invoice-contents"
              value={this.state.contents[0]}
              onChange={e => this.setState({ contents: [e.target.value] })}
            >
              <option value="星巴克预付款卡销售">星巴克预付款卡销售</option>
              <option value="星巴克预付款卡销售 – 星礼卡">星巴克预付款卡销售 – 星礼卡</option>
            </select>
          </div>
        </div>
        <br/>
        <Contact
          ref="contact"
          intl={this.props.intl}
          resetExtras={::this.resetExtras}
          addressee={addressee}
          postcode={postcode}
          phone={phone}
          billAddress={billAddress}
          onChangeAddressee={addressee =>
            this.setState({ extras: { ...this.state.extras, addressee } })}
          onChangePostCode={postcode =>
            this.setState({ extras: { ...this.state.extras, postcode } })}
          onChangeBillAddress={billAddress =>
            this.setState({ extras: { ...this.state.extras, billAddress } })}
          onChangePhone={phone =>
            this.setState({ extras: { ...this.state.extras, phone } })}
        />
        <div className="actions margin i-have-two-buttons" style={{width: "100%"}}>
          <FormattedMessage id="Back">
            {text => (
              <button
                className="button large back"
                onClick={::this.goBack}
                disabled={this.state.requesting}
              >
                {text}
              </button>
            )}
          </FormattedMessage>
          {this.state.requesting ? (
            <div className="waiting">
              <span />
            </div>
          ) : (
            <FormattedMessage id="Submit">
              {text => (
                <button
                  className="button large primary"
                  onClick={::this.onClickSubmit}
                >
                  {text}
                </button>
              )}
            </FormattedMessage>
          )}
        </div>
        <FormattedMessage id="Reminder">
          {text => <p className="subhead-2">{text}</p>}
        </FormattedMessage>
        <FormattedMessage
          tagName="p"
          id="Please provide correct contact and billing information to ensure your benefit."
        />
      </div>
    )
  }
}

export default injectIntl(Form)
